// A failed file download (request made with responseType "blob") still comes back
// as a Blob: the server's JSON error body, e.g.
//   {"success":false,"message":"Subscription is not active."}
// Saving that Blob produces a broken file, so callers check it first and show the
// message instead. Returns the message when `result` is such an error, else null.
export const getBlobErrorMessage = async (result) => {
  if (!(result instanceof Blob) || !/json/i.test(result.type || "")) {
    return null;
  }
  try {
    const parsed = JSON.parse(await result.text());
    if (parsed && parsed.success === false) {
      return parsed.message || "Unable to download the file. Please try again.";
    }
  } catch (error) {
    // Not JSON — treat as a real file.
  }
  return null;
};
